<template>
  <div>
    <BoxAddPartes :edit="editParte"
                  :prop-cartorio="propCartorio"
                  :prop-show-modal="showModal"
                  class="BoxAddPartes"
                  @partEdited="partEdited"
                  @DocumentoRemoved="documentoRemoved"
                  @sendParte="receiveParte"
                  @removeEndereco="removeEndereco"
                  @hideModal="hideModal" />
    <div v-if="genitores.length"
         class="row mb-4">
      <div v-for="(genitor, ind) in genitores"
           :key="ind"
           class="col-6">
        <BoxGenitorParte :dados="{...genitor, declarante: genitor.declarante || !!genitor.genitorParte}"
                         :indice="ind"
                         @changeDeclarante="changeDeclarante" />
      </div>
    </div>
    <BoxGenitores v-for="(parte, ind) in partes"
                  :key="ind"
                  :pessoa="{ ...parte, ...parte.pessoa, pessoa: parte.pessoa }">
      <slot>
        <button type="button"
                class="btn btn-sm btn-danger mr-2"
                @click="removeParte(parte, parte.indice)">
          Remover
        </button>

        <button class="btn btn-sm btn-primary"
                type="button"
                @click="editingParte(parte, parte.indice)">
          Editar
        </button>
      </slot>
    </BoxGenitores>

    <button class="btn btn-sm btn-outline-primary btn-block btn-add-parte"
            type="button"
            @click="showModal = true">
      <IconSvg class="icon-add mr-1"
               icon="add" />
      Adicionar parte
    </button>

    <h4 class="headerTitle my-4">
      Complementos
    </h4>

    <div class="px-2">
      <div class="form-group">
        <label for="complemento"
               class="label">Complementos</label>
        <textarea id="complemento"
                  v-model="complemento"
                  class="form-control form-control-sm"
                  name="complemento"
                  placeholder="Digite aqui suas observações."
                  rows="4"
                  @change="changeData" />
      </div>
    </div>

    <h4 class="headerTitle my-4">
      Gestação e parto
    </h4>

    <form class="px-2">
      <div class="row">
        <div class="col-12 col-sm-3 col-md-2">
          <div class="form-group">
            <label class="label"
                   for="idadeMae">Idade da mãe na ocorrência</label>
            <input id="idadeMae"
                   v-model="nascimento_informacao.idade_mae"
                   class="form-control form-control-sm"
                   maxlength="2"
                   max="99"
                   min="1"
                   name="idadeMae"
                   placeholder="00"
                   type="number"
                   @input="validateNull('idade_mae')"
                   @change="changeData">
          </div>
        </div>

        <div class="col-12 col-sm-3">
          <div class="form-group">
            <label class="label"
                   for="filhosVivosAnteriores">Nº dos filhos vivos em gestações anteriores</label>
            <input id="filhosVivosAnteriores"
                   v-model="nascimento_informacao.total_filhos_vivos_gestacoes_anteriores"
                   class="form-control form-control-sm"
                   maxlength="2"
                   max="20"
                   min="0"
                   name="filhosVivosAnteriores"
                   placeholder="00"
                   type="number"
                   @change="changeData">
          </div>
        </div>

        <div class="col-12 col-sm-3">
          <div class="form-group">
            <label class="label"
                   for="filhosMortosAnteriores">Nº de filhos mortos em gestações anteriores</label>
            <input id="filhosMortosAnteriores"
                   v-model="nascimento_informacao.total_filhos_mortos_gestacoes_anteriores"
                   class="form-control form-control-sm"
                   maxlength="2"
                   max="20"
                   min="0"
                   name="filhosMortosAnteriores"
                   placeholder="00"
                   type="number"
                   @change="changeData">
          </div>
        </div>

        <div class="col-12 col-sm-3 col-md-2">
          <div class="form-group">
            <label class="label"
                   for="semanadasDeGestacao">Nº de semanas de gestação</label>
            <input id="semanadasDeGestacao"
                   v-model="nascimento_informacao.total_semanas_gestacao"
                   class="form-control form-control-sm"
                   :disabled="ignorarSemanasGestacao"
                   maxlength="2"
                   max="50"
                   min="12"
                   name="semanadasDeGestacao"
                   placeholder="00"
                   type="number"
                   @change="changeData">
          </div>
        </div>

        <div class="col-12 col-sm-auto align-self-end mb-sm-1">
          <div class="form-group">
            <div class="custom-control custom-switch">
              <input id="ingoraSemanasGestacao"
                     v-model="ignorarSemanasGestacao"
                     class="custom-control-input"
                     name="ingoraSemanasGestacao"
                     type="checkbox"
                     @change="changeSemanasGestacao"
                     @keyup.enter="changeGestacao">
              <label class="custom-control-label"
                     for="ingoraSemanasGestacao">Ignorado</label>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-sm-3">
          <div class="form-group">
            <label class="label"
                   for="tipoGravidez">Tipo de gravidez</label>
            <select id="tipoGravidez"
                    v-model="nascimento_informacao.tipo_gravidez"
                    class="custom-select custom-select-sm"
                    name="tipoGravidez"
                    @change="changeData">
              <option v-for="(tipo, ind) in TIPOS_GRAVIDEZ"
                      :key="ind"
                      :value="tipo.value">
                {{ tipo.text }}
              </option>
            </select>
          </div>
        </div>

        <div class="col-12 col-sm-3">
          <div class="form-group">
            <label class="label"
                   for="tipoParto">Tipo de parto</label>
            <select id="tipoParto"
                    v-model="nascimento_informacao.tipo_parto"
                    class="custom-select custom-select-sm"
                    name="tipoParto"
                    @change="changeData">
              <option v-for="(tipo, ind) in TIPOS_PARTO"
                      :key="ind"
                      :value="tipo.value">
                {{ tipo.text }}
              </option>
            </select>
          </div>
        </div>

        <div class="col-12 col-sm-3">
          <div class="form-group">
            <label class="label"
                   for="consultasPreNatal">Nº de consultas pré-natal</label>
            <input id="consultasPreNatal"
                   v-model="nascimento_informacao.total_consultas_pre_natal"
                   class="form-control form-control-sm"
                   :disabled="ignorarConsultasPreNatal"
                   maxlength="2"
                   max="2000"
                   min="0"
                   name="consultasPreNatal"
                   placeholder="00"
                   type="number"
                   @change="changeData">
          </div>
        </div>

        <div class="col-12 col-sm-auto align-self-end mb-sm-1">
          <div class="form-group">
            <div class="custom-control custom-switch">
              <input id="ingoraPreNatal"
                     v-model="ignorarConsultasPreNatal"
                     class="custom-control-input"
                     name="registros"
                     type="checkbox"
                     @change="changeConsultasPreNatal"
                     @keyup.enter="changePreNatal">
              <label class="custom-control-label"
                     for="ingoraPreNatal">Ignorado</label>
            </div>
          </div>
        </div>
      </div>
    </form>

    <h4 class="headerTitle my-4">
      Recém nascido
    </h4>

    <form class="px-2">
      <div class="row">
        <div class="col-12 col-sm-auto">
          <div class="form-group">
            <label class="label"
                   for="indUmMinuto">Índice apgar 1º minuto</label>
            <input id="indUmMinuto"
                   v-model="nascimento.indice_apgar_1_minuto"
                   class="form-control form-control-sm"
                   maxlength="2"
                   max="99"
                   min="1"
                   name="indUmMinuto"
                   placeholder="00"
                   type="number"
                   @change="changeData">
          </div>
        </div>

        <div class="col-12 col-sm-auto">
          <div class="form-group">
            <label class="label"
                   for="indCincoMinuto">Índice apgar 5º minuto</label>
            <input id="indCincoMinuto"
                   v-model="nascimento.indice_apgar_5_minuto"
                   class="form-control form-control-sm"
                   maxlength="2"
                   max="99"
                   min="1"
                   name="indCincoMinuto"
                   placeholder="00"
                   type="number"
                   @change="changeData">
          </div>
        </div>

        <div class="col-12 col-sm-auto">
          <div class="form-group">
            <label class="label"
                   for="corPele">Cor de Pele</label>
            <select id="corPele"
                    v-model="nascimento.cor_pele"
                    class="custom-select custom-select-sm"
                    name="corPele"
                    @change="changeData">
              <option value=""
                      selected>
                Selecione
              </option>
              <option v-for="cor in CORES_PELE"
                      :key="cor.value"
                      :value="cor.value">
                {{ cor.name }}
              </option>
            </select>
          </div>
        </div>

        <div class="col-12 col-sm-auto">
          <div class="form-row">
            <div>
              <label class="label"
                     for="pesoNascido">Peso ao Nascer</label>
              <input id="pesoNascido"
                     v-model="nascimento.peso"
                     v-mask="{ mask:'9999' }"
                     class="form-control form-control-sm col-5"
                     maxlength="4"
                     max="9999"
                     step="100"
                     min="100"
                     name="pesoNascido"
                     placeholder="0000"
                     type="text"
                     @change="changeData">
            </div>
            <div class="col-12 col-sm-auto align-self-end alignPeso">
              <label class="label">gramas(g)</label>
            </div>
          </div>
        </div>

        <div class="col-12">
          <div class="form-group form-inline align-items-center">
            <label class="label mr-4"
                   for="defeitosCongenitosNao">Possui anomalias e/ou defeitos congênitos?</label>
            <div class="d-inline-block">
              <span class="custom-control custom-radio custom-control-inline">
                <input id="defeitosCongenitosSim"
                       v-model="possuiAnomalia"
                       class="custom-control-input"
                       name="defeitosCongenitos"
                       type="radio"
                       :value="true">
                <label class="custom-control-label"
                       for="defeitosCongenitosSim">Sim</label>
              </span>

              <span class="custom-control custom-radio custom-control-inline">
                <input id="defeitosCongenitosNao"
                       v-model="possuiAnomalia"
                       class="custom-control-input"
                       checked
                       name="defeitosCongenitos"
                       type="radio"
                       :value="false"
                       @click="eraseAnomalia">
                <label class="custom-control-label"
                       for="defeitosCongenitosNao">Não</label>
              </span>
            </div>
          </div>
        </div>

        <div v-if="possuiAnomalia"
             class="col-12">
          <div class="form-group">
            <label for="anomalias_ou_defeitos"
                   class="label">Qual ?</label>
            <input id="anomalias_ou_defeitos"
                   v-model="nascimento.anomalias_ou_defeitos"
                   class="form-control form-control-sm"
                   name="anomalias_ou_defeitos"
                   :required="possuiAnomalia"
                   placeholder="Descrever todas as anomalias ou defeitos congênitos observados"
                   type="text"
                   @change="changeData">
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import BoxAddPartes from '../../BoxAddPartes.vue'
  import BoxGenitorParte from '../../BoxGenitorParte.vue'
  import BoxGenitores from '../../../Obito/BoxGenitores.vue'
  import CORES_PELE from "@/constants/coresPele"
  import { TIPOS_PARTO, TIPOS_GRAVIDEZ } from "@/constants/dataGravidez"
  import Swal from 'sweetalert2'
  import objSwal from '@/constants/swalValues'

  export default {
    name: "AbaOutrasInfo",
    inject: ['$validator'],
    components: {
      BoxAddPartes,
      BoxGenitores,
      BoxGenitorParte,
    },
    props: {
      data: {
        type: Object,
        default: () => ({})
      },
      propCartorio: {
        type: Object,
        default: () => ({})
      },
      propFlags: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {
        CORES_PELE,
        TIPOS_PARTO,
        TIPOS_GRAVIDEZ,
        // dados que vem da API
        possuiAnomalia: false,
        editParte: {},
        nascimento: {
          cor_pele: '',
        },
        deleteds: {  partes: [], pessoaDocumentos: [], pessoaEnderecos: [] },
        nascimento_informacao: {
          tipo_gravidez: '',
          tipo_parto: '',
        },
        complemento: '',
        registro: {},
        partesList: [],
        genitores: [],
        ignorarSemanasGestacao: false,
        ignorarConsultasPreNatal: false,
        showModal: false,
      }
    },
    computed: {
      partes () {
        if (!this.partesList.length) return []

        return this.partesList.filter((parte, index) => {
          const genitor = this.genitores.find((genitor) => {
            if (genitor.genitorParte) {
              const parte_id = genitor.genitorParte.parte_id

              if (parte_id === parte.parte_id) return genitor
            }
          })

          parte.indice = index

          if (!genitor) {
            return parte
          }
        })
      }
    },
    watch: {
      data (newObj, oldObj) {
        if (Object.entries(newObj).length) this.setData(newObj)
      },
      propFlags () {
        this.ignorarSemanasGestacao = this.propFlags.ignorar_gestacao
        this.ignorarConsultasPreNatal = this.propFlags.ignorar_consultas
      }
    },
    beforeMount () {
      this.id = this._uid

      if (Object.entries(this.data).length) this.setData(this.data)
    },
    methods: {
      checkParte (list) {
        let check = list.filter((val, ind) => (val.tipo === 'DECLARANTE') && (val.registro_id === this.data.registro_id))

        if (!check.length) return []

        return check[0]
      },
      eraseAnomalia () {
        this.nascimento.anomalias_ou_defeitos = ''
        this.possuiAnomalia = false
        this.changeData()
      },
      setData (val) {
        this.partesList = val.registro.partes
        this.genitores = val.registro.pessoa.genitores
        this.complemento = val.registro.complemento
        this.nascimento = { ...val.recemNascido }
        this.nascimento_informacao = { ...val.nascimentoInformacao }
        this.possuiAnomalia = !!val.recemNascido ? val.recemNascido.anomalias_ou_defeitos : null

      },
      changeConsultasPreNatal () {
        if (this.ignorarConsultasPreNatal) this.nascimento_informacao.total_consultas_pre_natal = 0
        else this.nascimento_informacao.total_consultas_pre_natal = null

        this.changeData()
      },
      changeSemanasGestacao () {
        if (this.ignorarSemanasGestacao) this.nascimento_informacao.total_semanas_gestacao = 0
        else this.nascimento_informacao.total_semanas_gestacao = null

        this.changeData()
      },
      changeData () {
        let obj = { ...this.data }

        obj.registro.pessoa.genitores = this.genitores
        obj.registro.partes = this.partesList
        obj.registro.complemento = this.complemento
        obj.recemNascido = { ...this.nascimento }
        obj.nascimentoInformacao = { ...this.nascimento_informacao }
        obj.deleteds = this.deleteds

        this.$validator.validateAll().then((resp) => {
          if (resp) { this.$emit('updateInfo', obj) }
        })
      },
      getAnError (text) {
        loader({ text: '', active: false })

        objSwal.error.title = 'Erro ao cadastrar'
        objSwal.error.text = text || 'Houve algum erro ao cadastrar um novo registro de nascimento, favor contactar o suporte'
        return Swal.fire(objSwal.error).then(result => loader({ text: '', active: false }))
      },
      // receive data
      receiveParte (val) {
        let duplicated = false
        let parteObj = null

        const partes = [
          ...this.partesList,
          ...this.genitores
        ]

        if (val.pessoa.cpf) {
          partes.forEach((parte) => {
            if (parte.pessoa.cpf && val.pessoa.cpf.replace(/\D+/g, '') === parte.pessoa.cpf.replace(/\D+/g, '')) {
              parteObj = parte
              duplicated = true
            }
          })
        }

        if (duplicated) {
          objSwal.error.title = `Erro ao cadastrar a parte ${val.pessoa.nome}`
          objSwal.error.text = `CPF já cadastrado para a parte ${parteObj.pessoa.nome}`
          objSwal.error.html = ''

          return Swal.fire(objSwal.error)
        }

        this.partesList.push(val)
        this.changeData()
        this.showModal = false
      },
      editingParte (obj, indice) {
        this.editParte = { indice, edicao: true, ...obj }
        this.showModal = true
      },
      partEdited (val) {
        this.partesList.splice(val.indice, 1)
        this.partesList.push(val.objToAdd)
        Alerts.info("Parte atualizada com Sucesso!")
        this.showModal = false
        this.changeData()
      },
      async removeParte (parte) {
        const ind = this.partesList.findIndex(part => part == parte)

        const question = await Alerts.question(`Deseja excluir "${parte.pessoa.nome}"?`)

        if (question && ind !== -1) {
          this.partesList.splice(ind, 1)

          Alerts.info("Parte removida com Sucesso!")

          if (parte.parte_id) {
            this.deleteds.partes.push(parte.parte_id)
          }

          this.changeData()
        }
      },
      documentoRemoved (documento) {
        this.deleteds.pessoaDocumentos.push(documento.pessoa_documento_id)
        this.changeData()
      },
      changeDeclarante (val) {
        this.genitores[val.indice] = { ...this.genitores[val.indice], genitorParte: null, declarante: val.declarante }
        this.changeData()
      },
      removeEndereco (endereco) {
        this.deleteds.pessoaEnderecos.push(endereco.endereco_id)
        this.changeData()
      },
      hideModal (value) {
        this.editParte = {}
        this.showModal = value
      },
      changePreNatal () {
        setTimeout(() => {
          this.ignorarConsultasPreNatal = !this.ignorarSemanasGestacao

          this.changeConsultasPreNatal()
        }, 200)
      },
      changeGestacao () {
        setTimeout(() => {
          this.ignorarSemanasGestacao = !this.ignorarSemanasGestacao

          this.changeSemanasGestacao()
        }, 200)
      },

      validateNull (key) {
        if (this.nascimento_informacao[key] == '') {
          this.nascimento_informacao[key] = null
        }
      }
    },
  }
</script>

<style lang="scss">
  @import '../../../../../scss/_utilities/_exports';

    .alignPeso{
    position: relative;
    right:100px;
  }

  .BoxAddPartes {
    margin-top: 0 !important;
  }
</style>
